/**
 * オブジェクトが文字列かどうかを判定
 * @param {*} obj
 */
export function isString(obj) {
  return typeof obj == 'string' || obj instanceof String;
}
